module.exports = __webpack_public_path__ + "img/comdex-small-dark.76abcd73.svg";